import {PipeTransform} from "@angular/core";
import {FormatConfigService} from "../../core/services/format-config.service";
import {FormatConfigEntry} from "../../core/base-api";
import {PlatformLocation} from "@angular/common";
import {ComponentLocationStrategy} from "../services/location-strategy/component-location-strategy";

/**
 * Abhängig von der Konfiguration ({@geoLink FormatConfigService} -> {@geoLink FormatConfigEntry}) liefert diese Klasse einen
 * unterschiedlichen string {@geoLink transform()}
 *
 * Für Kompaktdarstellungen mit Design-Output, siehe {@geoLink KompaktDarstellungsKomponent}
 **/
export abstract class KompaktdarstellungPipe<T> implements PipeTransform {

  protected templateElement: FormatConfigEntry.ElementEnum;

  constructor(protected formatService: FormatConfigService,
              protected type: FormatConfigEntry.TypeEnum,
              protected location: PlatformLocation,
              protected componentLocation: ComponentLocationStrategy) {
  }

  /**
   * Holt das konfigurierte Format
   */
  get formatElement(): FormatConfigEntry.ElementEnum {
    const path = location.pathname.substring(location.pathname.indexOf("/", 1) + 1);
    const format: FormatConfigEntry = this.formatService.formatConfig.getFormat(this.type, path, this.componentLocation.componentId());
    if (format && format.element) {
      return this.templateElement = format.element;
    }
    return null;
  }

  /**
   * Konvertiert einen Wert vom Typ T abhängig von der konfigurierten Kompaktdarstellung zu einem Text {@link toString()}
   * @param model: Wert
   * @param languageChangeEvent: Pipes werden sonst nicht upgedated nach Seitenerstellung bei Sprachumstellung
   *        -> LanguageChange erzeugt Par.Wechsel
   *
   * @return Kompaktdarstellung in Text-Form
   */
  abstract transform(model: T, model2?: any): string;

}
